import Axios from 'axios';
import { THIRD_PARTY_APPS } from 'constants/constants';

interface ThirdPartyApp {
  id: string;
  token_exits?: boolean;
  app_enabled: boolean;
  is_app_email: boolean;
}

const APP_EVENT_CONFIG: Array<{
  appId: string;
  event: 'email_connected' | 'storage_connected';
  provider: string;
}> = [
  { appId: 'googlemail', event: 'email_connected', provider: 'gmail' },
  { appId: 'outlookemail', event: 'email_connected', provider: 'outlook' },
  {
    appId: 'googledrive',
    event: 'storage_connected',
    provider: 'google_drive',
  },
  { appId: 'onedrive', event: 'storage_connected', provider: 'onedrive' },
  { appId: 'sharepoint', event: 'storage_connected', provider: 'sharepoint' },
];

export type TrackEventFn = (
  eventName: string,
  properties?: Record<string, unknown>,
) => void;

export const trackThirdPartyConnections = async (
  trackEvent?: TrackEventFn,
) => {
  if (!trackEvent) return;

  try {
    const response = await Axios.get(THIRD_PARTY_APPS);
    const apps: ThirdPartyApp[] = response?.data?.data ?? [];

    APP_EVENT_CONFIG.forEach(({ appId, event, provider }) => {
      const connectedApp = apps.find(
        (app) => app.id === appId && app.token_exits,
      );
      if (connectedApp) {
        trackEvent(event, {
          user_role: 'firm_employee',
          provider,
          onboarding_step: event,
          source: 'onboarding',
        });
      }
    });
  } catch (error) {
    console.error('Failed to check third party connections:', error);
  }
};
